import { render, staticRenderFns } from "./SendiSettings.vue?vue&type=template&id=d7dcff64&lang=pug&"
import script from "./SendiSettings.vue?vue&type=script&lang=js&"
export * from "./SendiSettings.vue?vue&type=script&lang=js&"
import style0 from "./SendiSettings.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports